<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <SocialMediaPost />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import SocialMediaPost from "./components/SocialMediaPost";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "tables",
  components: {
    SocialMediaPost,
    // ProjectsTable,
  },
};
</script>
